<!-- 寄修完整信息 -->
<template>
  <div class="detail-wrap">
    <!-- 时间和地址 -->
    <div class="user-detail">
      <!-- repairType 1-预约，2-寄修，3-上门维修，6-同城快修 -->
      <!-- 预约到店 -->
      <template v-if="repairType == 1">
        <div class="user-detail-item">
          <div class="detail-item-title os-font-14-500">预约网点所在地</div>
          <div
            @click="selectedProvince"
            v-if="appointmentAddress && appointmentAddress.city"
            class="detail-item-content fixed-height os-font-14-400"
          >
            {{ appointmentAddress.province }} {{ appointmentAddress.city }}
            {{ appointmentAddress.district }}
          </div>
          <div v-else class="detail-item-loading os-font-14-400">定位中</div>
        </div>
        <div
          v-if="appointmentAddress && appointmentAddress.city"
          class="user-detail-item item-space"
        >
          <div class="detail-item-service-website os-font-14-500">
            匹配到服务网点
            <div
              v-if="appointmentSiteList.length > 1"
              @click="seeMoreSite"
              class="see-more-website os-font-12-400"
            >
              更多网点
            </div>
          </div>
          <div ref="appointmentSiteWrap" class="detail-item-service-address os-font-14-400">
            <template v-if="appointmentSite.siteName">
              <div class="sevice-branch">
                {{ appointmentSite.siteName }}
                <div v-if="appointmentSite.distance" class="near-icon"></div>
              </div>
              <div
                class="sevice-branch-detail-reserve"
                :class="{ 'no-distance': !appointmentSite.distance }"
                @click="goToMap(appointmentSite)"
              >
                <div class="service-branch-address os-font-12-400">
                  {{ appointmentSite.address }}
                </div>
                <div v-if="appointmentSite.distance" class="site-distance os-font-12-400">
                  {{ appointmentSite.distance }}km
                </div>
              </div>
              <div class="sevice-branch-time os-font-12-400">
                <div class="sevice-branch-time-detail">
                  {{ appointmentSite.businessTime }} （休息日：{{ appointmentSite.restTime }}）
                </div>
              </div>
              <div
                v-if="splitPhone(appointmentSite.newPhone).length === 1"
                class="sevice-branch-phone os-font-12-400"
              >
                <div class="sevice-phone-wrap">
                  <a class="branch-phone-detail" :href="`tel:${appointmentSite.newPhone}`">{{
                    appointmentSite.newPhone
                  }}</a>
                </div>
              </div>
              <div
                v-else
                class="sevice-branch-phone os-font-12-400"
                @click="selectPhone(splitPhone(appointmentSite.newPhone))"
              >
                <div class="sevice-phone-wrap">
                  <div class="branch-phone-detail">{{ appointmentSite.newPhone }}</div>
                </div>
              </div>
              <div
                v-if="appointmentSite.hasRest && appointmentSite.restDescription"
                class="sevice-branch-remark os-font-12-400"
              >
                <div class="branch-remake-detail">
                  {{ appointmentSite.restDescription }}
                </div>
              </div>
            </template>
            <div v-else class="no-service-website">
              <div class="no-service-website-bg"></div>
              <div class="no-service-website-tips os-font-14-400">
                当前地址未匹配到合适的服务网点<br />您可尝试<span
                  class="change-service"
                  @click="changeService"
                  >切换服务方式</span
                >
              </div>
            </div>
          </div>
        </div>
        <template v-if="appointmentSite.siteName">
          <div class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">到店时间</div>
            <div
              style="outline: none"
              tabindex="0"
              @blur="appointmentCheck.timeError = false"
              ref="appointmentTimeWrap"
              :class="[
                'detail-item-content fixed-height os-font-14-400',
                { 'item-error': appointmentCheck.timeError }
              ]"
              @click="selectRepairTime"
            >
              {{ selectedTime.showTime ? selectedTime.showTime : '请选择到店时间' }}
            </div>
          </div>
          <div class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">联系信息</div>
            <div
              ref="userNameWrap"
              :class="['des-add os-font-14-400', { 'item-error': appointmentCheck.userNameError }]"
            >
              <van-field
                @blur="verifyUserName"
                maxlength="20"
                ref="userName"
                v-model="appointmentOrder.userName"
                placeholder="请填写姓名"
              />
            </div>
            <div
              ref="userPhoneWrap"
              :class="[
                'des-add os-font-14-400 phone-space',
                {
                  'item-error': appointmentCheck.phoneError,
                  'border-mark-bg': appointmentCheck.phoneFocus
                }
              ]"
            >
              <van-field
                ref="userPhone"
                type="tel"
                maxlength="11"
                @blur="verifyPhone"
                v-model="appointmentOrder.userPhone"
                placeholder="请填写手机号码"
              />
            </div>
          </div>
          <div class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">备注说明</div>
            <div class="des-add os-font-14-400">
              <van-field
                :class="{ 'des-add-unsame': appointmentOrder.remark.length == 100 }"
                v-model="appointmentOrder.remark"
                maxlength="100"
                rows="1"
                autosize
                type="textarea"
                show-word-limit
                placeholder="请详细描述设备故障或要求（选填）"
              />
            </div>
          </div>
          <div v-if="showPhoneVerification" class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">联系方式验证</div>
            <div :class="['des-add os-font-14-400', { 'item-error': false }]">
              <van-field readonly v-model="appointmentOrder.checkPhone" />
            </div>
            <div class="change-self-phone os-font-14-400">
              请您核对手机号，如需修改<span class="change-phone" @click="changeAppointmentPhone"
                >点击此处</span
              >
            </div>
            <div
              ref="sendCodeWrap"
              :class="['des-add os-font-14-400 phone-space-top', { 'item-error': smsCodeError }]"
            >
              <van-field
                @blur="setSmsCode"
                ref="sendCode"
                v-model="appointmentOrder.smsCode"
                placeholder="请输入验证码"
              />
              <div class="user-self-phone-countdown" v-if="counting">
                重新获取（{{ countdown }}s）
              </div>
              <div
                @click="sendImeiCode(appointmentOrder.checkPhone)"
                v-else
                class="user-self-phone"
              >
                发送验证码
              </div>
            </div>
          </div>
        </template>
      </template>
      <!-- 寄修 -->
      <template v-if="repairType == 2">
        <div class="user-detail-item">
          <div class="detail-item-title os-font-14-500">上门取件时间</div>
          <div
            ref="repairTimeWrap"
            :class="[
              'detail-item-content fixed-height os-font-14-400',
              { 'item-error': repairCheck.timeError }
            ]"
            @click="selectRepairTime"
          >
            {{ selectedTime.showTime ? selectedTime.showTime : '请选择上门取件时间' }}
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">上门取件地址</div>
          <div
            v-if="pickupAddress && pickupAddress.receiverName"
            class="detail-item-content pickup-item-content os-font-14-400"
            @click="selectPickupAddress"
          >
            <div class="pickup-detail">
              <div class="pickup-user">
                {{ pickupAddress.receiverName }} {{ pickupAddress.mobilePhone }}
              </div>
              <div class="pickup-address os-font-12-400">
                {{ pickupAddress.province }} {{ pickupAddress.city }} {{ pickupAddress.area }}
                {{ pickupAddress.detailAddress }}
              </div>
            </div>
          </div>
          <div
            v-else
            ref="pickupAddressWrap"
            :class="[
              'pickup-detail-add fixed-height os-font-14-400',
              { 'item-error': repairCheck.sendAddressError }
            ]"
            @click="selectPickupAddress"
          >
            {{ addressList && addressList.length ? '选择地址' : '添加地址' }}
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">匹配到的服务网点</div>
          <div class="detail-item-service-address os-font-14-400">
            <template v-if="sendReapairSite && sendReapairSite.siteName">
              <div class="sevice-branch">
                {{ sendReapairSite.siteName }}
              </div>
              <div class="sevice-branch-detail os-font-12-400" @click="goToMap(sendReapairSite)">
                <div class="service-branch-address">
                  {{ sendReapairSite.address }}
                </div>
              </div>
              <div class="sevice-branch-time os-font-12-400">
                <div class="sevice-branch-time-detail">
                  {{ sendReapairSite.businessTime }} （休息日：{{ sendReapairSite.restTime }}）
                </div>
              </div>
              <div
                v-if="splitPhone(sendReapairSite.newPhone).length === 1"
                class="sevice-branch-phone os-font-12-400"
              >
                <div class="sevice-phone-wrap">
                  <a class="branch-phone-detail" :href="`tel:${sendReapairSite.newPhone}`">{{
                    sendReapairSite.newPhone
                  }}</a>
                </div>
              </div>
              <div
                v-else
                class="sevice-branch-phone os-font-12-400"
                @click="selectPhone(splitPhone(sendReapairSite.newPhone))"
              >
                <div class="sevice-phone-wrap">
                  <div class="branch-phone-detail">{{ sendReapairSite.newPhone }}</div>
                </div>
              </div>
            </template>
            <div v-else class="no-service-website">
              <div class="no-service-website-bg"></div>
              <div
                v-if="pickupAddress.province && !sendReapairSite.siteName"
                class="no-service-website-tips os-font-14-400"
              >
                当前地址未匹配到合适的服务网点<br />您可尝试<span
                  class="change-service"
                  @click="changeService"
                  >切换服务方式</span
                >
              </div>
              <div v-else class="no-service-website-tips os-font-14-400">
                填写地址后将为您推荐服务网点
              </div>
            </div>
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">修后寄返地址</div>
          <div
            ref="receiveAddressWrap"
            :class="[
              'detail-item-recive-address os-font-14-400',
              { 'item-error': repairCheck.receiveAddressError }
            ]"
          >
            <div class="recive-address-wrap">
              <div class="recice-address-left">与取件地址是否一致？</div>
              <div class="recice-address-right os-font-12-400">
                <div
                  :class="[
                    'recice-address-right-yes',
                    { 'recice-address-right-no': !isSameAddress }
                  ]"
                  @click="changeSameAddress(true)"
                >
                  是
                </div>
                <div
                  :class="[
                    'recice-address-right-no address-margin',
                    { 'recice-address-right-unsame': !isSameAddress }
                  ]"
                  @click="changeSameAddress(false)"
                >
                  否
                </div>
              </div>
            </div>
            <template v-if="!isSameAddress">
              <div
                v-if="receiveAddress && receiveAddress.receiverName"
                class="detail-item-content-recive pickup-item-content os-font-14-400"
                @click="selectReciveAddress"
              >
                <div class="pickup-detail">
                  <div class="pickup-user">
                    {{ receiveAddress.receiverName }} {{ receiveAddress.mobilePhone }}
                  </div>
                  <div class="pickup-address os-font-12-400">
                    {{ receiveAddress.province }} {{ receiveAddress.city }}
                    {{ receiveAddress.area }} {{ receiveAddress.detailAddress }}
                  </div>
                </div>
              </div>
              <div
                v-else
                @click="selectReciveAddress"
                :class="['recive-address-add', 'fixed-height']"
              >
                {{ addressList.length ? '选择地址' : '添加地址' }}
              </div>
            </template>
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">备注说明</div>
          <div class="des-add os-font-14-400">
            <van-field
              :class="{ 'des-add-unsame': sendReapairOrderInfo.remark.length == 100 }"
              v-model="sendReapairOrderInfo.remark"
              maxlength="100"
              rows="1"
              autosize
              type="textarea"
              show-word-limit
              placeholder="请详细描述设备故障或要求（选填）"
            />
          </div>
          <div v-if="showPhoneVerification" class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">联系方式验证</div>
            <div :class="['des-add os-font-14-400', { 'item-error': false }]">
              <van-field readonly v-model="pickupAddress.mobilePhone" />
            </div>
            <div class="change-self-phone os-font-14-400">
              请您核对手机号，如需修改<span class="change-phone" @click="changeRepairPhone"
                >点击此处</span
              >
            </div>
            <div
              ref="sendCodeWrap"
              :class="['des-add os-font-14-400 phone-space-top', { 'item-error': smsCodeError }]"
            >
              <van-field
                @blur="setSmsCode"
                ref="sendCode"
                v-model="sendReapairOrderInfo.smsCode"
                placeholder="请输入验证码"
              />
              <div class="user-self-phone-countdown" v-if="counting">
                重新获取（{{ countdown }}s）
              </div>
              <div @click="sendImeiCode(pickupAddress.mobilePhone)" v-else class="user-self-phone">
                发送验证码
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 上门维修 -->
      <template v-if="repairType == 3">
        <div class="user-detail-item">
          <div class="detail-item-title os-font-14-500">
            IMEI 1码/SN
            <span class="imei-help-icon" @click="showImeiHelp"></span>
          </div>
          <div
            ref="imeiCodeWrap"
            :class="['des-add os-font-14-400', { 'item-error': homeReapairCheck.imeiError }]"
          >
            <van-field
              @blur="checkImeiCode"
              ref="imeiCode"
              v-model="homeReapairOrderInfo.imeiCode"
              placeholder="请填写设备码"
            />
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">上门地址</div>
          <div
            v-if="pickupAddress && pickupAddress.receiverName"
            class="detail-item-content pickup-item-content os-font-14-400"
            @click="selectPickupAddress"
          >
            <div class="pickup-detail">
              <div class="pickup-user">
                {{ pickupAddress.receiverName }} {{ pickupAddress.mobilePhone }}
              </div>
              <div class="pickup-address os-font-12-400">
                {{ pickupAddress.province }} {{ pickupAddress.city }} {{ pickupAddress.area }}
                {{ pickupAddress.detailAddress }}
              </div>
            </div>
          </div>
          <div
            v-else
            ref="pickupAddressWrap"
            :class="[
              'pickup-detail-add fixed-height os-font-14-400',
              { 'item-error': repairCheck.sendAddressError }
            ]"
            @click="selectPickupAddress"
          >
            {{ addressList && addressList.length ? '选择地址' : '添加地址' }}
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">工程师上门时间</div>
          <div
            ref="repairTimeWrap"
            :class="[
              'detail-item-content os-font-14-400',
              { 'item-error': homeReapairCheck.timeError }
            ]"
            @click="selectRepairTime"
          >
            {{ selectedTime.showTime ? selectedTime.showTime : '请选择工程师上门时间' }}
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">匹配到的服务网点</div>
          <div class="detail-item-service-address os-font-14-400">
            <template v-if="homeReapairSite && homeReapairSite.siteName">
              <div class="sevice-branch">
                {{ homeReapairSite.siteName }}
              </div>
              <div class="sevice-branch-detail os-font-12-400" @click="goToMap(homeReapairSite)">
                <div class="service-branch-address">
                  {{ homeReapairSite.address }}
                </div>
              </div>
              <div class="sevice-branch-time os-font-12-400">
                <div class="sevice-branch-time-detail">
                  {{ homeReapairSite.businessTime }} （休息日：{{ homeReapairSite.restTime }}）
                </div>
              </div>
              <div
                v-if="splitPhone(homeReapairSite.newPhone).length === 1"
                class="sevice-branch-phone os-font-12-400"
              >
                <div class="sevice-phone-wrap">
                  <a class="branch-phone-detail" :href="`tel:${homeReapairSite.newPhone}`">{{
                    homeReapairSite.newPhone
                  }}</a>
                </div>
              </div>
              <div
                v-else
                class="sevice-branch-phone os-font-12-400"
                @click="selectPhone(splitPhone(homeReapairSite.newPhone))"
              >
                <div class="sevice-phone-wrap">
                  <div class="branch-phone-detail">{{ homeReapairSite.newPhone }}</div>
                </div>
              </div>
            </template>
            <div v-else class="no-service-website">
              <div class="no-service-website-bg"></div>
              <div
                v-if="selectedTime.time && !homeReapairSite.siteName"
                class="no-service-website-tips os-font-14-400"
              >
                当前地址未匹配到合适的服务网点<br />您可尝试<span
                  class="change-service"
                  @click="changeService"
                  >切换服务方式</span
                >
              </div>
              <div v-else class="no-service-website-tips os-font-14-400">
                填写工程师上门时间后将为您推荐服务网点
              </div>
            </div>
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">备注说明</div>
          <div class="des-add os-font-14-400">
            <van-field
              :class="{ 'des-add-unsame': homeReapairOrderInfo.remark.length == 100 }"
              v-model="homeReapairOrderInfo.remark"
              maxlength="100"
              rows="1"
              autosize
              type="textarea"
              show-word-limit
              placeholder="请详细描述设备故障或要求（选填）"
            />
          </div>
          <div v-if="showPhoneVerification" class="user-detail-item item-space">
            <div class="detail-item-title os-font-14-500">联系方式验证</div>
            <div :class="['des-add os-font-14-400', { 'item-error': false }]">
              <van-field readonly v-model="pickupAddress.mobilePhone" />
            </div>
            <div class="change-self-phone os-font-14-400">
              请您核对手机号，如需修改<span class="change-phone" @click="changeRepairPhone"
                >点击此处</span
              >
            </div>
            <div
              ref="sendCodeWrap"
              :class="['des-add os-font-14-400 phone-space-top', { 'item-error': smsCodeError }]"
            >
              <van-field
                @blur="setSmsCode"
                ref="sendCode"
                v-model="homeReapairOrderInfo.smsCode"
                placeholder="请输入验证码"
              />
              <div class="user-self-phone-countdown" v-if="counting">
                重新获取（{{ countdown }}s）
              </div>
              <div @click="sendImeiCode(pickupAddress.mobilePhone)" v-else class="user-self-phone">
                发送验证码
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 同城快修 -->
      <template v-if="repairType == 6">
        <div class="user-detail-item">
          <div class="detail-item-title os-font-14-500">上门取件时间</div>
          <div
            ref="repairTimeWrap"
            :class="[
              'detail-item-content fixed-height os-font-14-400',
              { 'item-error': repairCheck.timeError }
            ]"
            @click="selectRepairTime"
          >
            {{ selectedTime.showTime ? selectedTime.showTime : '请选择上门取件时间' }}
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">上门取件地址</div>
          <div
            v-if="quickRepairSendAddressInfo && quickRepairSendAddressInfo.receiverName"
            class="detail-item-content pickup-item-content os-font-14-400"
            @click="selectPickupAddress"
          >
            <div class="pickup-detail">
              <div class="pickup-user">
                {{ quickRepairSendAddressInfo.receiverName }}
                {{ quickRepairSendAddressInfo.mobilePhone }}
              </div>
              <div class="pickup-address os-font-12-400">
                {{ quickRepairSendAddressInfo.detailAddress }}
              </div>
            </div>
          </div>
          <div
            v-else
            ref="pickupAddressWrap"
            :class="[
              'pickup-detail-add fixed-height os-font-14-400',
              { 'item-error': repairCheck.sendAddressError }
            ]"
            @click="selectPickupAddress"
          >
            添加地址
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">匹配到的服务网点</div>
          <div class="detail-item-service-address os-font-14-400">
            <div v-if="QuickRepairSite && QuickRepairSite.siteName">
              <div class="sevice-branch">{{ QuickRepairSite.siteName }}</div>
              <div @click="goToMap(QuickRepairSite)" class="sevice-branch-detail os-font-12-400">
                <div class="service-branch-address">
                  {{ QuickRepairSite.address }}
                </div>
              </div>
              <div class="sevice-branch-time os-font-12-400">
                <div class="sevice-branch-time-detail">
                  {{ QuickRepairSite.businessTime }} ({{ QuickRepairSite.restTime }})
                </div>
              </div>
              <div
                v-if="splitPhone(QuickRepairSite.newPhone).length === 1"
                class="sevice-branch-phone os-font-12-400"
              >
                <div class="sevice-phone-wrap">
                  <a
                    class="branch-phone-detail"
                    :href="`tel:${splitPhone(QuickRepairSite.newPhone)}`"
                    >{{ QuickRepairSite.newPhone }}</a
                  >
                </div>
              </div>
              <div
                v-else
                class="sevice-branch-phone os-font-12-400"
                @click="selectPhone(splitPhone(QuickRepairSite.newPhone))"
              >
                <div class="sevice-phone-wrap">
                  <div class="branch-phone-detail">{{ QuickRepairSite.newPhone }}</div>
                </div>
              </div>
            </div>
            <div v-else class="no-service-website">
              <div class="no-service-website-bg"></div>
              <div
                v-if="quickRepairSendAddressInfo.detailAddress"
                class="no-service-website-tips os-font-14-400"
              >
                当前{{ isSupportQuick ? '地址' : '城市' }}未匹配到合适的服务网点<br />您可尝试<span
                  class="change-service"
                  @click="changeService"
                  >切换服务方式</span
                >
              </div>
              <div v-else class="no-service-website-tips os-font-14-400">
                填写地址后将为您推荐服务网点
              </div>
            </div>
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">修后送返地址</div>
          <div
            ref="receiveAddressWrap"
            :class="[
              'detail-item-recive-address os-font-14-400',
              { 'item-error': repairCheck.receiveAddressError }
            ]"
          >
            <div class="recive-address-wrap">
              <div class="recice-address-left">与取件地址是否一致？</div>
              <div class="recice-address-right os-font-12-400">
                <div
                  :class="[
                    'recice-address-right-yes',
                    { 'recice-address-right-no': !isSameAddress }
                  ]"
                  @click="changeSameAddress(true)"
                >
                  是
                </div>
                <div
                  :class="[
                    'recice-address-right-no address-margin',
                    { 'recice-address-right-unsame': !isSameAddress }
                  ]"
                  @click="changeSameAddress(false)"
                >
                  否
                </div>
              </div>
            </div>
            <template v-if="!isSameAddress">
              <div
                v-if="quickRepairReceiveAddressInfo && quickRepairReceiveAddressInfo.receiverName"
                class="detail-item-content-recive pickup-item-content os-font-14-400"
                @click="selectReciveAddress"
              >
                <div class="pickup-detail">
                  <div class="pickup-user">
                    {{ quickRepairReceiveAddressInfo.receiverName }}
                    {{ quickRepairReceiveAddressInfo.mobilePhone }}
                  </div>
                  <div class="pickup-address os-font-12-400">
                    {{ quickRepairReceiveAddressInfo.detailAddress }}
                  </div>
                </div>
              </div>
              <div v-else @click="selectReciveAddress" class="recive-address-add">添加地址</div>
            </template>
          </div>
        </div>
        <div class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">备注说明</div>
          <div class="des-add os-font-14-400">
            <van-field
              :class="{ 'des-add-unsame': quickRepairOrderInfo.remark.length == 100 }"
              v-model="quickRepairOrderInfo.remark"
              maxlength="100"
              rows="1"
              autosize
              type="textarea"
              show-word-limit
              placeholder="请详细描述设备故障或要求（选填）"
            />
          </div>
        </div>
        <div v-if="showPhoneVerification" class="user-detail-item item-space">
          <div class="detail-item-title os-font-14-500">联系方式验证</div>
          <div :class="['des-add os-font-14-400', { 'item-error': false }]">
            <van-field readonly v-model="quickRepairSendAddressInfo.mobilePhone" />
          </div>
          <div class="change-self-phone os-font-14-400">
            请您核对手机号，如需修改<span class="change-phone" @click="changeQuickRepairPhone"
              >点击此处</span
            >
          </div>
          <div
            ref="sendCodeWrap"
            :class="['des-add os-font-14-400 phone-space-top', { 'item-error': smsCodeError }]"
          >
            <van-field
              @blur="setSmsCode"
              ref="sendCode"
              v-model="quickRepairOrderInfo.smsCode"
              placeholder="请输入验证码"
            />
            <div class="user-self-phone-countdown" v-if="counting">
              重新获取（{{ countdown }}s）
            </div>
            <div
              @click="sendImeiCode(quickRepairSendAddressInfo.mobilePhone)"
              v-else
              class="user-self-phone"
            >
              发送验证码
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 上门不展示协议 -->
    <div
      v-if="isSHowPolice && showPoloice"
      ref="policeAgreeWrap"
      class="police-agree os-font-12-400"
    >
      <div :class="['agree-icon', { 'agree-icon-select': isAgreed }]" @click="selectAgree"></div>
      我已阅读并同意<a
        href="https://www.vivo.com/about-vivo/service-privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        >《vivo官网隐私政策》</a
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { verifyCodeSend } from '../../../api'
import { isPhone } from 'utils/reg'
import toast from '@/utils/toast'
import API from '@/api/index.js'

export default {
  name: 'detailContent',
  props: {
    addressList: {
      type: Array,
      default: () => []
    },
    isSHowPolice: {
      type: Boolean,
      default: true
    },
    isWeChatApp: {
      type: Boolean,
      default: false
    },
    isSupportQuick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      appointmentCheck: {
        timeError: false,
        userNameError: false,
        phoneError: false,
        phoneFocus: false
      },
      repairCheck: {
        timeError: false,
        sendAddressError: false,
        receiveAddressError: false
      },
      homeReapairCheck: {
        imeiError: false,
        addressError: false,
        timeError: false
      },
      smsCodeError: false,
      showPhoneCheck: false,
      phoneChange: false,
      counting: false, // 是否正在倒计时
      countdown: 60 // 初始倒计时时间
    }
  },
  computed: {
    ...mapState('repair', [
      'appointmentAddress',
      'appointmentSite',
      'appointmentSiteList',
      'sendReapairSite',
      'homeReapairSite',
      'selectedTime',
      'repairType',
      'isSameAddress',
      'pickupAddress',
      'receiveAddress',
      'isAgreed',
      'showPhoneVerification',
      'quickRepairSendAddressInfo',
      'quickRepairReceiveAddressInfo',
      'QuickRepairSite',
      'appointmentOrder',
      'homeReapairOrderInfo',
      'sendReapairOrderInfo',
      'quickRepairOrderInfo',
      'userPhone',
      'repairTimeList'
    ]),
    showPoloice() {
      return this.repairType == 1
        ? !!(this.appointmentAddress && this.appointmentAddress.city)
        : true
    }
  },
  methods: {
    ...mapMutations('repair', [
      'SET_PICKER_ADDRESS',
      'SET_REPAIR_ADDRESS',
      'setIsSameAddress',
      'setIsAgreed',
      'setAppointmentOrderAgreed',
      'setAddressSelectType'
    ]),
    ...mapActions('repair', ['jumpToH5', 'getTimeList']),
    resetState() {
      this.appointmentCheck = {
        timeError: false,
        userNameError: false,
        phoneError: false,
        phoneFocus: false
      }
      this.repairCheck = {
        timeError: false,
        sendAddressError: false,
        receiveAddressError: false
      }
      this.homeReapairCheck = {
        imeiError: false,
        addressError: false,
        timeError: false
      }
      this.smsCodeError = false
      this.showPhoneCheck = false
    },
    selectedProvince() {
      let addresTemp = {
        province: this.appointmentAddress.province,
        city: this.appointmentAddress.city,
        area: this.appointmentAddress.district
      }
      this.SET_PICKER_ADDRESS(addresTemp)
      this.$emit('selectedProvince')
    },
    selectRepairTime() {
      // 上门取件时间依赖取件地址
      if (this.repairType == 3 && !this.pickupAddress.receiverName) {
        toast('请先选择上门取件地址')
        return
      }
      this.repairTimeList || this.getTimeList()
      this.$emit('selectRepairTime')
    },
    selectPickupAddress() {
      this.setAddressSelectType(1)
      this.$emit('selectPickupAddress')
    },
    changeQuickRepairPhone() {
      this.$emit('changeQuickRepairPhone')
    },
    selectReciveAddress() {
      this.setAddressSelectType(2)
      this.$emit('selectReciveAddress')
    },
    seeMoreSite() {
      this.$emit('seeMoreSites')
    },
    // 是否和区间地址一致
    changeSameAddress(val) {
      this.setIsSameAddress(val)
      this.repairCheck.receiveAddressError = false
      this.$emit('changeSameAddress')
    },
    selectAgree() {
      this.setIsAgreed(!this.isAgreed)
    },
    async goToMap(site) {
      if (this.isWeChatApp) {
        // 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
        let res = await API.getWxSignature()
        if (res.retCode == 200 && res.data) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
          })
          window.wx.ready(() => {
            window.wx.openLocation({
              longitude: site.longitude,
              latitude: site.latitude,
              name: site.siteName,
              address: site.address,
              scale: 15
            })
          })
          window.wx.error(() => {
            console.log('error')
          })
        }
      } else {
        this.jumpToH5(
          `https://uri.amap.com/marker?position=${site.longitude},${site.latitude}&name=${encodeURIComponent(site.siteName)}&coordinate=gaode&callnative=0`
        )
      }
    },
    // 电话份分离
    splitPhone(phone) {
      if (phone) {
        return phone.split('/')
      } else {
        return ''
      }
    },
    selectPhone(phoneList) {
      this.$emit('selectPhone', phoneList)
    },
    // 切换服务方式
    changeService() {
      this.$emit('changeService')
    },
    showImeiHelp() {
      this.$emit('showImeiHelp')
    },
    changePhone() {
      this.phoneChange = true
      this.$nextTick(() => {
        this.$refs.homeUserPhone.focus()
      })
    },
    // 发送验证码
    async sendImeiCode(phone) {
      const params = {
        mobile: phone,
        type: this.repairType == 3 ? 2 : this.repairType
      }
      let res = await verifyCodeSend(params)
      if (res.code == 0) {
        this.startCountDown()
      } else {
        toast(res.msg)
      }
    },
    startCountDown() {
      if (!this.counting) {
        this.counting = true
        this.countdown = 60
        // 启动倒计时定时器
        const timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--
          } else {
            this.counting = false
            clearInterval(timer) // 清除定时器
          }
        }, 1000)
      }
    },
    changeAppointmentPhone() {
      this.$nextTick(() => {
        this.appointmentCheck.phoneFocus = true
        this.$refs.userPhone.focus()
        this.$refs.userPhoneWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    changeRepairPhone() {
      this.$emit('changeRepairPhone')
    },
    repairTimeSelect() {
      this.$nextTick(() => {
        this.appointmentCheck.timeError = true
        this.$refs.appointmentTimeWrap.focus()
        this.$refs.appointmentTimeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    // 选择用户姓名
    userNameSelect() {
      this.$nextTick(() => {
        this.appointmentCheck.userNameError = true
        this.$refs.userName.focus()
        this.$refs.userNameWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    userPhoneSelect() {
      this.$nextTick(() => {
        this.appointmentCheck.phoneError = true
        this.$refs.userPhone.focus()
        this.$refs.userPhoneWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    repairTimeCheck() {
      this.$nextTick(() => {
        this.repairCheck.timeError = true
        this.$refs.repairTimeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    repairSendAddressCheck() {
      this.$nextTick(() => {
        this.repairCheck.sendAddressError = true
        this.$refs.pickupAddressWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    repairReceiveAddressCheck() {
      this.$nextTick(() => {
        this.repairCheck.receiveAddressError = true
        this.$refs.receiveAddressWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    repairTimeWrapCheck() {
      this.$nextTick(() => {
        this.homeReapairCheck.timeError = true
        this.$refs.repairTimeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    sendCodeWrapCheck() {
      this.$nextTick(() => {
        this.smsCodeError = true
        this.$refs.sendCode.focus()
        this.$refs.sendCodeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    setSmsCode() {
      this.smsCodeError = false
    },
    checkImeiCode() {
      this.homeReapairCheck.imeiError = false
    },
    iemiCodeCheck() {
      this.$nextTick(() => {
        this.homeReapairCheck.imeiError = true
        this.$refs.imeiCodeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    pickupAddressWrapCheck() {
      this.$nextTick(() => {
        this.homeReapairCheck.addressError = true
        this.$refs.imeiCodeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    policeAgreeWrapCheck() {
      this.$nextTick(() => {
        this.$refs.policeAgreeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    verifyUserName() {
      this.appointmentCheck.userNameError = false
    },
    // 验证手机号
    verifyPhone() {
      // 如果是手机号开始校验
      if (isPhone(this.appointmentOrder.userPhone)) {
        this.appointmentCheck.phoneError = false
        this.appointmentCheck.phoneFocus = false
        this.$emit('verifyPhone', this.appointmentOrder.userPhone)
      } else {
        this.appointmentCheck.phoneFocus = false
        this.appointmentCheck.phoneError = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes locationMark {
  0% {
    border: 1px solid #415fff;
  }

  100% {
    border: 1px solid transparent;
  }
}

.detail-wrap {
  margin: 0 16px;
  max-width: 664px;
  @media screen and (min-width: 698px) {
    margin: 0 auto;
  }

  .border-mark-bg {
    border: 1px solid #415fff;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .phone-change {
    border: 1px solid #415fff;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .user-detail {
    margin-top: 12px;
    border-radius: 12px;
    background: #fff;
    padding: 16px 16px;

    .vivo-dark-mode & {
      background-color: #f7f7f7;
    }

    .user-detail-item {
      &.item-space {
        margin-top: 20px;
      }

      .detail-item-title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        color: #333;
        // padding: 13px 14px;
        .imei-help-icon {
          margin-left: 5px;
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/price-help.svg') center center no-repeat;
        }
      }

      .detail-item-service-website {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .see-more-website {
          display: flex;
          align-items: center;
          color: #999;

          &::after {
            margin-left: 3px;
            display: block;
            content: '';
            width: 8px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/more-site.svg') center center
              no-repeat;
            background-size: contain;
          }
        }
      }

      .detail-item-content {
        border: 1px solid transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 13px 10px 13px 14px;
        border-radius: 6px;
        background: #fafafa;
        color: #333;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &.fixed-height {
          box-sizing: border-box;
          height: 44px;
          padding: 0 10px 0 14px;
        }

        &.pickup-item-content {
          align-items: flex-start;

          .pickup-detail {
            flex: 1;

            .pickup-user {
              color: #333;
              line-height: 16px;
            }

            .pickup-address {
              margin-top: 8px;
              color: #999;
              line-height: 18px;
            }
          }
        }

        &::after {
          display: block;
          content: '';
          margin-left: 4px;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center no-repeat;
          background-size: contain;
        }
      }

      .detail-item-content-recive {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fafafa;
        color: #333;
        margin-top: 16px;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &.pickup-item-content {
          align-items: flex-start;

          .pickup-detail {
            flex: 1;

            .pickup-user {
              color: #333;
              line-height: 16px;
            }

            .pickup-address {
              margin-top: 8px;
              color: #999;
              line-height: 18px;
            }
          }
        }

        &::after {
          display: block;
          content: '';
          margin-left: 4px;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center no-repeat;
          background-size: contain;
        }
      }

      .pickup-detail-add {
        border: 1px solid transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 13px 10px 13px 14px;
        border-radius: 6px;
        background: #fafafa;
        color: #333;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &.fixed-height {
          box-sizing: border-box;
          height: 44px;
          padding: 0 10px 0 14px;
        }

        &::after {
          display: block;
          content: '';
          margin-left: 4px;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/address-add.svg') center center
            no-repeat;
          background-size: contain;
        }
      }

      .detail-item-loading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 13px 14px;
        border-radius: 6px;
        background: #fafafa;
        color: #333;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &::after {
          display: block;
          content: '';
          margin-right: -4px;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/location_icon.svg') center center
            no-repeat;
          background-size: contain;
          animation: rotate 3s linear infinite; /* 应用旋转动画 */
        }
      }

      .detail-item-service-address {
        padding: 13px 10px 13px 14px;
        border-radius: 6px;
        box-sizing: border-box;
        background: #fafafa;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        .sevice-branch {
          color: #242933;
          line-height: 16px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;

          .near-icon {
            margin-left: 6px;
            display: inline-block;
            width: 26px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/near-icon.svg') center center
              no-repeat;
            background-size: contain;
          }
        }

        .sevice-branch-detail {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 9px;

          .service-branch-address {
            flex: 1;
            color: #999;
            line-height: 18px;
          }

          &::before {
            display: block;
            content: '';
            margin-right: 8px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/address-icon.svg') center center
              no-repeat;
            background-size: contain;
          }

          &::after {
            display: block;
            content: '';
            margin-left: 16px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center
              no-repeat;
            background-size: contain;
          }
        }

        .sevice-branch-detail-reserve {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 9px;

          .service-branch-address {
            flex: 1;
            color: #999;
            line-height: 18px;
          }

          &::before {
            display: block;
            content: '';
            margin-right: 8px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/address-icon.svg') center center
              no-repeat;
            background-size: contain;
          }

          .site-distance {
            color: #415fff;
            display: flex;
            align-items: center;
            margin-left: 14px;

            &::before {
              display: block;
              content: '';
              margin-right: 11px;
              width: 1px;
              height: 12px;
              background: url('~@/assets/img/repair/confirm/wap/split-icon.svg') center center
                no-repeat;
              background-size: contain;
            }

            &::after {
              display: block;
              content: '';
              width: 16px;
              height: 16px;
              background: url('~@/assets/img/repair/confirm/wap/blue-right-icon.svg') center center
                no-repeat;
              background-size: contain;
            }
          }

          &.no-distance {
            &::after {
              display: block;
              content: '';
              width: 16px;
              height: 16px;
              background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center
                no-repeat;
              background-size: contain;
            }
          }
        }

        .sevice-branch-time {
          display: flex;
          align-items: center;
          margin-bottom: 9px;
          color: #999;
          line-height: 18px;
          padding-right: 32px;

          .sevice-branch-time-detail {
            flex: 1;
          }

          &::before {
            display: block;
            content: '';
            margin-right: 8px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/time-icon.svg') center center
              no-repeat;
            background-size: contain;
          }
        }

        .sevice-branch-phone {
          display: flex;
          align-items: center;

          .sevice-phone-wrap {
            flex: 1;
            display: flex;
            align-items: center;

            .branch-phone-detail {
              color: #999;
              line-height: 18px;
            }
          }

          &::before {
            display: block;
            content: '';
            margin-right: 8px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/tel-icon.svg') center center no-repeat;
            background-size: contain;
          }

          &::after {
            display: block;
            content: '';
            margin-left: 16px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center
              no-repeat;
            background-size: contain;
          }
        }

        .sevice-branch-remark {
          display: flex;
          align-items: flex-start;
          margin-top: 9px;

          .branch-remake-detail {
            flex: 1;
            color: #f67a0c;
            line-height: 18px;
          }

          &::before {
            display: block;
            content: '';
            margin-right: 8px;
            width: 16px;
            height: 16px;
            background-image: url('data:image/svg+xml;base64,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');
            background-size: 100% 100%;
            flex-shrink: 0;
            position: relative;
            top: 1px;
          }
        }

        .no-service-website {
          display: flex;
          flex-direction: column;
          padding: 17px 2px;
          box-sizing: border-box;

          .no-service-website-bg {
            margin: 0 auto 12px;
            display: block;
            width: 48px;
            height: 48px;
            background: url('~@/assets/img/repair/confirm/wap/website.svg') center center no-repeat;
            background-size: contain;
          }

          .no-service-website-tips {
            color: #999;
            text-align: center;
            line-height: 16px;

            .change-service {
              color: #415fff;
            }
          }
        }
      }

      .detail-item-recive-address {
        border: 1px solid transparent;
        padding: 13px 14px;
        border-radius: 6px;
        background: #fafafa;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        .recive-address-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .recice-address-right {
            display: flex;
            align-items: center;

            .recice-address-right-yes {
              border-radius: 24px;
              color: #fff;
              width: 48px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #415fff;

              .vivo-dark-mode & {
                background-color: #3a56e6;
              }
            }

            .recice-address-right-no {
              border-radius: 24px;
              background: #ededed;
              color: #333;
              width: 48px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;

              .vivo-dark-mode & {
                background-color: #ededed;
              }
            }

            .recice-address-right-unsame {
              border-radius: 24px;
              color: #fff;
              width: 48px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              background-color: #415fff;

              .vivo-dark-mode & {
                background-color: #3a56e6;
              }
            }

            .address-margin {
              margin-left: 12px;
            }
          }
        }

        .recive-address-add {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 13px;
          height: 16px;
          padding-top: 14px;
          border-top: 1px solid #f5f5f5;
          // box-sizing: border-box;

          &::after {
            display: block;
            content: '';
            margin-left: 16px;
            margin-right: -4px;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center
              no-repeat;
            background-size: contain;
          }
        }
      }

      .phone-space {
        margin-top: 10px;
      }

      .phone-space-top {
        margin-top: 20px;
      }

      .change-self-phone {
        margin-top: 8px;
        color: #999;

        .change-phone {
          color: #415fff;
        }
      }

      .des-add {
        position: relative;
        border: 1px solid transparent;

        .user-self-phone {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #415fff;
          cursor: pointer;
        }

        .user-self-phone-countdown {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #999999;
          cursor: pointer;
        }

        .connect-phone {
          padding: 13px 14px;
          border-radius: 6px;
          background: #fafafa;
          color: #333;

          .vivo-dark-mode & {
            background-color: #282828;
          }
        }

        .change-phone-tips {
          margin-top: 8px;
          color: #999;

          span {
            color: #415fff;
            cursor: pointer;
          }
        }
      }

      ::v-deep .van-field {
        padding: 13px 14px;
        border-radius: 6px;
        background: #fafafa;
        color: #333;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        &::placeholder {
          color: #999;
        }

        &::after {
          border: 0px;
        }

        .van-field__control {
          color: #333;
          line-height: 18px;

          &::placeholder {
            color: #999 !important;
          }
        }

        .van-field__word-limit {
          color: #999;
        }

        &.des-add-unsame {
          .van-field__word-limit {
            color: #f10313;
          }
        }
      }
    }
  }

  .police-agree {
    margin-top: 16px;
    margin-bottom: 20px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;

    .agree-icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      background: url('~@/assets/img/repair/confirm/wap/unselect.svg') center center no-repeat;
      background-size: contain;
    }

    .agree-icon-select {
      background: url('~@/assets/img/repair/confirm/wap/select_agree.svg') center center no-repeat;
      background-size: contain;
    }

    a {
      color: #415fff;
    }
  }

  .item-error {
    border: 1px solid rgba(241, 3, 19, 1) !important;
    border-radius: 6px;
    box-sizing: border-box;
  }
}
</style>
